import styled from "styled-components";

export const ContentsTopWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 3rem 2rem;
  border-bottom: 2px solid #e0e0e0;
  .l {
    display: flex;
    /* gap: 0.8rem; */
    align-items: center;
    .back-arrow {
      button {
        display: flex;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
    .icon-box {
      display: flex;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      letter-spacing: -0.05rem;
    }
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    .l {
      .icon-box {
      }
      p {
        font-size: 1.8rem;
      }
    }
    .r {
      width: 100%;
    }
  }
`;

export const SearchFormContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2.4rem;
  .l {
    .search-select {
      .react-select__single-value {
        font-size: 1.2rem;
        color: #555;
      }
    }
    .react-select__control {
      min-height: 3.4rem;
    }
  }
  .r {
    display: flex;
    gap: 1.2rem;
    .input-box {
      input {
        font-size: 1.4rem;
        font-weight: 100;
        border-radius: 0.6rem;
        outline: none;
        border: 1px solid #ebebeb;
        padding: 8px 20px;
        min-width: 32rem;
      }
    }
    button {
      background-color: #323232;
      color: white;
      font-size: 1.4rem;
      line-height: 1;
      letter-spacing: -0.05rem;
      border-radius: 0.6rem;
      min-width: 6.5rem;
      outline: 0;
      border: 0;
    }
  }
  @media screen and (max-width: 768px) {
    .l {
    }
    .r {
      .input-box {
        width: 100%;
        input {
          min-width: 100px;
          width: 100%;
        }
      }
    }
  }
`;
